import { useSite } from "../context/SiteContext";
import { waLink, KISS } from "../lib/wa";
import { trackWa, trackOf } from "../lib/analytics";

export default function Footer() {
  const { content } = useSite();
  return (
    <footer
      className="border-t border-[rgba(201,169,97,0.15)] py-10 px-5 md:px-8 mt-6"
      data-testid="site-footer"
    >
      <div className="container-x flex flex-col md:flex-row gap-6 md:items-end md:justify-between">
        <div>
          <div className="font-display text-2xl text-gold mb-2">Camilla XXX</div>
          <p className="text-xs md:text-sm text-[color:var(--muted)] max-w-md leading-relaxed">
            Independent, legal, NSW-decriminalised. 18+ only. All content on
            this site is protected — please do not repost.
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-3">
          <div className="flex gap-4">
            <a
              href={waLink(`Hi Camilla ${KISS}`)}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
              data-testid="footer-wa-link"
              onClick={() => trackWa("footer")}
            >
              WhatsApp · {content.contact?.phone_display || "0437 780 132"}
            </a>
            <a
              href={
                content.onlyfans_url ||
                content.onlyfans ||
                "https://onlyfans.com/camilla.xxx?rec=485728775"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
              data-testid="footer-of-link"
              onClick={() => trackOf("footer")}
            >
              OnlyFans
            </a>
          </div>
          <div className="text-xs text-[color:var(--muted)] flex items-center gap-3 md:justify-end">
            <span>© 2026 Camilla XXX · Sydney, Australia</span>
            <a
              href="/admin"
              className="footer-admin-link"
              data-testid="footer-admin-link"
            >
              admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
